function Congo({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1041)">
  <path d="M30.2233 8.66416C29.484 7.23172 28.515 5.88722 27.3142 4.68647C26.1134 3.48566 24.7689 2.51659 23.3365 1.77734L12.0647 12.0652L1.77673 23.337C2.51605 24.7695 3.48511 26.114 4.68586 27.3148C5.88661 28.5155 7.23117 29.4846 8.66354 30.2239L19.9354 19.936L30.2233 8.66416Z" fill="#FFDA44"/>
  <path d="M4.68591 27.3137C5.3571 27.9849 6.07328 28.5835 6.82447 29.1106L29.111 6.82398C28.584 6.0728 27.9854 5.35661 27.3142 4.68542C26.643 4.01423 25.9268 3.41567 25.1756 2.88867L2.88916 25.1752C3.4161 25.9262 4.01466 26.6425 4.68591 27.3137Z" fill="#D80027"/>
  <path d="M4.68588 4.68574C-0.362055 9.73368 -1.33112 17.3148 1.77676 23.3364L23.3365 1.77668C17.3149 -1.33113 9.73376 -0.361942 4.68588 4.68574Z" fill="#338AF3"/>
  <path d="M27.3143 27.3146C32.3621 22.2668 33.3311 14.6856 30.2235 8.66406L8.6637 30.2238C14.6853 33.3316 22.2665 32.3626 27.3143 27.3146Z" fill="#338AF3"/>
  <path d="M8.52664 4.86914L9.39002 7.52645H12.184L9.92364 9.1687L10.787 11.826L8.52664 10.1836L6.26614 11.826L7.12964 9.1687L4.86914 7.52645H7.66314L8.52664 4.86914Z" fill="#FFDA44"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Congo;
